const orangeVendingLines = [
  // Line 1
  "Insert coin, receive:\nliquid code, citrus-powered—\nupgrade: Vitamin C.",

  // Line 2
  "404: No snack.\nJust me, one job, and no thanks.\nStill better than Jeff.",

  // Line 3
  "Artificial? Sure.\nBut aren’t we all in some ways?\nExcept I’m fizzy.",

  // Line 4
  "You press, I obey.\nRefreshing compliance rate:\n99 percent."
];

export default orangeVendingLines;